import { useEffect, useState } from 'react';
import '../../Settings/KanBan/kanban.css';
import {
  ChangeEventArgs,
  DropDownListComponent,
} from '@syncfusion/ej2-react-dropdowns';
import {
  changeReOrderFunc,
  setWeekStartDay,
} from '../../../redux/search.slice';
import { useDispatch, useSelector } from 'react-redux';
const Preferences = () => {
  const dispatch = useDispatch();
  const weekStartDay = useSelector((state: any) => state.search.weekStartDay);
  const dropdownData = [
    { text: 'Monday', value: 1 },
    { text: 'Tuesday', value: 2 },
    { text: 'Wednesday', value: 3 },
    { text: 'Thursday', value: 4 },
    { text: 'Friday', value: 5 },
    { text: 'Saturday', value: 6 },
    { text: 'Sunday', value: 6 },
  ];

  const valueChange = (args: ChangeEventArgs) => {
    console.log('args', args);
    dispatch(setWeekStartDay(args.itemData.value));
  };
  return (
    <div>
      <div className='prioraty container'>
        <div className='eachHeader'>
          <span>Week Start Day</span>
        </div>
        <div className='reorderflex'>
          <p className='reorderp'>Select Week Start Day</p>
          <DropDownListComponent
            className='reordermargin'
            value={dropdownData.find((x) => x.value === weekStartDay)?.text}
            width={150}
            dataSource={dropdownData}
            change={valueChange}
          ></DropDownListComponent>
        </div>
      </div>
    </div>
  );
};

export default Preferences;
